export const resources = {
  es: {
    translation: {
      languageId: 'ES',
      welcome: 'Bienvenido',
      login: 'Entrar',
      profile: 'perfil',
      register: 'Registrarme',
      television: 'Televisión',
      showFilters: 'Mostrar filtros',
      filters: 'filtros',
      lockText: 'Por favor, gire el dispositivo para usar esta aplicación.',
      radio: 'Radio',
      writtenOrDigitalPress: 'Prensa escrita o digital',
      clubMedia: 'Medios oficiales de clubes',
      other: 'Otros',
      name: 'Nombre',
      lastName: 'Apellidos',
      dni: 'DNI/NIF',
      email: 'Email',
      mediaType: 'Tipo de medio',
      password: 'Contraseña',
      newPassword: 'Nueva contraseña',
      telephone: 'Número de teléfono',
      cancel: 'Cancelar',
      yes: 'Sí',
      no: 'No',
      season: 'Temporada',
      date: 'Fecha',
      confirm: 'Confirmar',
      registerConfirmation: 'Confirmación de registro',
      registerConfirmationMessage:
        'Revisa la bandeja de entrada del correo registrado para proceder a la validación del mismo',
      sendEmailAgain: 'Volver a enviar correo',
      sendEmail: 'Enviar correo',
      return: 'Volver',
      appName: 'Canal de Información de Partidos de TV',
      appNameShort: 'Canal de Información',
      changeLogo: 'Cambiar logo',
      logout: 'Cerrar sesión',
      deleteLogo: 'Borrar logo',
      arbiterTeam: 'Equipo arbitral',
      kitSelector: 'KitSelector',
      grassStatus: 'Estado del césped',
      matchSheet: 'Hoja de partido',
      protocolActs: 'Actos Protocolarios',
      commercials: 'Comerciales',
      commercial: 'Comercial',
      protocolary: 'Protocolario',
      arbitrationTeam: 'Equipo arbitral',
      countdown: 'Cuenta atrás',
      goBackTo: 'Volver al',
      next: 'Siguiente',
      accessAppInformation: 'Accede a la información de las',
      apps: 'Aplicaciones',
      allFemale: 'Todas',
      all: 'Todos',
      club: 'Club',
      competition: 'Competición',
      search: 'Buscar',
      cleanFilters: 'Limpiar filtros',
      noOptions: 'Sin opciones',
      round: 'Jornada',
      globalStatistics: 'Estadísticas globales',
      previous: 'Previa',
      direct: 'Directo',
      passesCompleted: 'Pases completados (número + porcentaje)',
      passesCompletedAbv: 'PCom',
      longPasses: 'Pases largos con éxito',
      longPassesAbv: 'PLCom',
      shortPasses: 'Pases cortos con éxito',
      shortPassesAbv: 'PCCom',
      shots: 'Disparos (número / a puerta)',
      shotsAbv: 'Dis',
      faults: 'Faltas (cometidas / recibidas)',
      faultsAbv: 'Fal',
      offsides: 'Fueras de juego',
      offsidesAbv: 'FJue',
      goal: 'Gol',
      goals: 'Goles',
      goalsAbv: 'Gol',
      ownGoal: 'Gol en propia',
      recoveredBalls: 'Balones recuperados',
      recoveredBallsAbv: 'BRec',
      minutesPlayed: 'Minutos jugados',
      minutesPlayedAbv: 'MinJ',
      totalTackle: 'Entradas realizadas',
      totalTackleAbv: 'EntR',
      head_coach: 'Entrenador',
      second_coach: 'Segundo entrenador',
      defender: 'Defensa',
      midfielder: 'Mediocampista',
      forward: 'Delantero',
      minuteByMinute: 'Minuto a minuto',
      events: 'Eventos',
      matchStatistics: 'Estadísticas del partido',
      dashboard: 'Dashboard',
      local: 'Local',
      localClub: 'Club local',
      peninsular: 'Peninsular',
      stadium: 'Estadio',
      rainfall: 'Precipitaciones',
      humidity: 'Humedad',
      temperature: 'Temperatura',
      accountValidated: 'Tu cuenta ha sido validada, ya puedes acceder a ella',
      activeAccount: 'Tu cuenta ya está activa',
      weekday0: 'Domingo',
      weekday1: 'Lunes',
      weekday2: 'Martes',
      weekday3: 'Miércoles',
      weekday4: 'Jueves',
      weekday5: 'Viernes',
      weekday6: 'Sábado',
      loading: 'Cargando',
      mainReferee: 'Árbitro principal',
      shirt: 'Camiseta',
      shorts: 'Pantalón',
      socks: 'Medias',
      irrigationProgramBeforeWarming: 'Antes del calentamiento',
      irrigationProgramBeforeMatch: 'Antes del partido',
      irrigationProgramDuringBreak: 'Al comienzo del descanso',
      'var-referee': 'VAR',
      'avar-referee': 'AVAR',
      'assistant-referee-1': 'A1',
      'assistant-referee-2': 'A2',
      'fourth-referee': '4º',
      // Validations
      loginError: 'Error de login',
      nameIsRequiredValidationError: 'Nombre es un campo obligatorio',
      lastNameIsRequiredValidationError: 'Apellidos es un campo obligatorio',
      dniIsRequiredValidationError: 'DNI/NIF es un campo obligatorio',
      emailIsRequiredValidationError: 'Email es un campo obligatorio',
      mediaNameIsRequiredValidationError:
        'Nombre de medio es un campo obligatorio',
      mediaTypeIsRequiredValidationError:
        'Tipo de medio es un campo obligatorio',
      telephoneIsRequiredValidationError:
        'Número de teléfono es un campo obligatorio',
      passwordIsRequiredValidationError: 'Contraseña es un campo obligatorio',
      newPasswordIsRequiredValidationError:
        'La nueva contraseña es un campo obligatorio',
      confirmPasswordIsRequiredValidationError:
        'La contraseña debe ser confirmada',
      captchaIsRequiredValidationError: 'Error al comprobar el captcha',
      changeLogoError: 'El logo de tu marca no ha podido ser cambiado',
      editAccountError: 'Tu perfil no ha podido ser cambiado',
      editAccountSuccess: 'Tu perfil se ha cambiado correctamente',
      editPasswordError: 'Tu contraseña no ha podido ser cambiado',
      editPasswordSuccess: 'Tu contraseña se ha cambiado correctamente',
      fileTypeNotPermitted: 'Tipo de archivo no admitido, debe ser jpg o png',
      mustChooseOption: 'Debes seleccionar una opción',
      mustHave2OrMoreLetters: 'Debe contener 2 o más caracteres',
      mustHave3OrMoreLetters: 'Debe contener 3 o más caracteres',
      mustHave15OrLessLetters: 'Debe contener 15 o menos caracteres',
      mustHave30OrLessLetters: 'Debe contener 30 o menos caracteres',
      mustHave50OrLessLetters: 'Debe contener 50 o menos caracteres',
      mustContainOnlyLetters: 'Debe contener sólo letras',
      documentFormatInvalid: 'El formato no es válido',
      invalidEmail: 'Email inválido',
      emailIsRequired: 'Email es obligatorio',
      properTelephoneSpanishFormat:
        'Debe ser un número de teléfono español válido',
      mustPassCaptcha: 'Confirma que no eres un robot',
      policyIsRequiredValidationError:
        'Es obligatorio la aceptación de los Términos Legales y la Política de Privacidad',

      // Form labels
      enterName: 'Introduce tu nombre',
      enterLastName: 'Introduce tus apellidos',
      enterDNI: 'Introduce tu DNI',
      enterEmail: 'Introduce tu email',
      mediaNameLabel: 'Nombre del medio',
      enterMediaName: 'Introduce el nombre del medio',
      selectMediaType: 'Selecciona el tipo de medio',
      enterMediaTypeDescription: 'Introduce el tipo de medio',
      enterTelephone: 'Introduce tu número de teléfono',
      enterPassword: 'Introduce tu contraseña',
      confirmPasswordLabel: 'Confirmar contraseña',
      confirmPassword: 'Confirma tu contraseña',
      confirmNewPassword: 'Confirma tu nueva contraseña',
      submit: 'Enviar',
      createAccount: 'Crear cuenta',
      editAccount: 'Editar cuenta',
      editPassword: 'Editar contraseña',
      profesionalAdvise:
        '* La información será tratada exclusivamente para uso profesional',
      haveAccount: '¿ Ya tienes cuenta ?',
      noHaveAccount: '¿ Aún no tienes cuenta ?',
      enterSmsCode: 'Introduce el código de verificación',
      smsCodeNotification_part_1:
        'Te hemos enviado un mensaje de texto al teléfono +XX XXXXXXX',
      smsCodeNotification_part_2: '. Escribe el código para iniciar sesión.',
      smsVerification: 'Comprobar',
      addLogo: 'Añadir logotipo',
      addImage: 'Adjuntar imagen',
      loginIntoAccount: 'Iniciar sesión',
      passwordRecovery: 'Recuperar contraseña',
      passwordIsRequired: 'Debes introducir una contraseña',
      passwordsMustMatch: 'Las contraseñas deben coincidir',
      smsCode: 'Código SMS',
      enterSMSCode: 'Introduce el código del SMS',
      smsCodeValidationError: 'Debes introducir un código',
      passwordFormatValidationError:
        'Debe tener entre 8 y 20 caracteres, una letra mayúscula, una letra minúscula, un numéro y un caracter especial',
      finalize: 'Finalizar',
      dropzoneMessage1: 'Arrastre la imagen que desee subir dentro del área',
      dropzoneMessage2: 'o haga click para poder seleccionar el archivo',
      changePassword: 'Cambiar contraseña',
      confirmationSuccessMessage:
        'Usuario validado con éxito. Por favor, introduce los datos para acceder a tu cuenta.',
      profileConditions:
        'Con el objetivo de poder mejorar mi experiencia, acepto que LaLiga elabore un perfil basado en mis hábitos de navegación y consumo.',
      legalText1: 'He leído y acepto los',
      legalTerms: 'Términos Legales',
      and: 'y la',
      privacyPolicy: 'Política de Privacidad',
      legalText2: 'de la plataforma, confirmando que soy mayor de 18 años',

      // Toasts
      authFailed: 'La autenticación ha fallado, verifique sus datos',
      registerFailed: 'El registro de nuevo usuario ha fallado',
      passwordRecoverySuccess: 'Sigue las instrucciones enviadas a tu correo',
      passwordRecoveryFailed: 'Recuperar contraseña ha fallado',
      faultsIndicated: 'Faltas indicadas',
      resendEmailSuccess: 'Se ha enviado un mensaje a tu email',
      resendEmailFailure: 'El email no ha podido ser enviado',
      changePasswordSuccess:
        'La contraseña ha sido reemplazada satisfactoriamente',
      changePasswordFailure: 'La contraseña no ha podido ser reemplazada',
      dataFetchFailure: 'Los datos no han podido ser recuperados',
      userActivated: 'El usuario ya está activado',
      // GLOBAL STATS
      namePosition: 'Nombre / posición',
      goalsNoKey: 'goles',
      passes: 'pases',
      recoveries: 'recuperaciones',
      assists: 'asistencias',
      stops: 'paradas',
      games: 'p.jugados',
      in: 'en',
      position: 'Posición',
      birthDate: 'Fecha de nacimiento',
      birthPlace: 'Lugar de nacimiento',
      height: 'Altura',
      weight: 'Peso',
      close: 'Cerrar',
      goalPenaltis: 'Goles / Penaltis',
      substitutions: 'Sustituciones',
      shotsNoKey: 'Disparos',
      yellowCards: 'Tarjetas amarillas',
      yellowCard: 'Tarjeta amarilla',
      redCards: 'Tarjetas rojas',
      redCard: 'Tarjeta roja',
      doubleYellowCards: 'Doble tarjeta amarilla',
      foulsReceivedMade: 'Faltas recibidas / Faltas realizadas',
      whistlesFouls: 'Faltas pitadas',
      penaltiesIndicated: 'Penaltis señalados',
      squad: 'Plantilla',
      stats: 'Estadísticas',
      information: 'Información',
      signaledPlayersAre: 'Los jugadores señalados son',
      inTheCategorySignaled: 'en las categorías que se indican de la temporada',
      inTheCategorySignaledMatch:
        'en las categorías que se indican del partido',
      offside: 'Fuera de juego',
      checkUrl:
        'Comprueba que has escrito correctamente la dirección de la página',
      uncaughtError:
        'Ha habido un error inesperado, por favor, póngase en contacto con la dirección soporte@laliga.es',
      goToWebsiteHome: 'Ir a canalinformacionpartidos.laliga.es',
      report: 'Informe',
      matchReports: 'Informes del partido',
      matchInfo: 'Info partido',
      documentUnavailable: 'Informe pendiente de cumplimentar',
      // MATCH
      titulars: 'Titulares',
      substitutes: 'Suplentes',
      alignment: 'Alineación',
      trainer: 'Entrenador',
      globalStats: 'Estadísticas club-competición',
      foundationYear: 'Año fundación',
      total_shots: 'Disparos totales',
      total_faults: 'Faltas totales',
      total_passes: 'Pases totales',
      possession_percentage: 'Porcentaje de posesión',
      double_yellow_card: 'Doble tarjeta amarilla',
      total_fouls_conceded: 'Faltas totales',
      red_card_2nd_yellow: 'Doble tarjeta amarilla',
      corners_won: 'Córners ganados',
      total_successful_passes_excl_crosses_corners: 'Total pases exitosos',
      total_shots_conceded: 'Total de disparos recibidos',
      total_red_cards: 'Tarjetas rojas totales',
      won_matches: 'Partidos ganados',
      total_losses_of_possession: 'Pérdidas totales de posesión',
      tied_matches: 'Partidos empatados',
      successful_corners_into_box: 'Goles de saques de esquina',
      corner: 'Córner',
      red_cards: 'Tarjetas rojas',
      yellow_cards: 'Tarjetas amarillas',
      total_passes_done: 'Total pases éxito',
      win_matches: 'Partidos ganados',
      total_possession_lost: 'Pérdidas totales de posesión',
      lost_matches: 'Partidos perdidos',
      tie_matches: 'Partidos empatados',
      corner_goals: 'Goles de saque de esquina',
      total_shots_received: 'Disparos totales recibidos',
      priorToBeginning: 'Antes del partido',
      duringBreak: 'Durante el descanso',
      afterTheMatch: 'Después del partido',
      period: 'Período',
      actType: 'Tipo de acto',
      description: 'Descripción',
      observations: 'Observaciones',
      noObservations: 'Sin observaciones',
      // REFEREES
      totalWinnings: 'Total victorias',
      totalDraws: 'Total empates',
      totalDefeats: 'Total derrotas',
      arbitratedMatches: 'Partidos arbitrados',
      matchesWithReferees: 'Partidos arbitrados',
      debut: 'Debut',
      arbitrationCollege: 'Colegio arbitral',
      total: 'total',
      // KIT SELECTOR
      equipment: 'Equipación',
      referee: 'Arbitral',
      rol: 'rol',
      time: 'Hora',
      kit: 'Equipación',
      rolHome: 'Local',
      rolAway: 'Visitante',
      downloadKitDesignation: 'Descargar designación oficial de KitSelector',
      downloadRefereeDesignation:
        'Descargar designación oficial de Equipo arbitral',
      downloadGrassDesignation: 'Descargar Informe sobre el estado del césped',
      downloadSheetDesignation: 'Descargar Hoja de Partido',
      downloadActsDesignation: 'Descargar Protocolo de cuenta atrás',
      goalkeeper: 'Portero',
      player: 'Jugador',
      countAcronim: 'ª',
      // GREENKEEPER
      meteorology: 'meteorología',
      pitch: 'terreno de juego',
      grass: 'césped',
      president: 'presidente',
      officialWeb: 'Web Oficial',
      relativeHumidity: 'Humedad relativa',
      precipitations: 'tipo precipitaciones',
      dimensions: 'dimensiones',
      floorTemperarure: 'Temperatura del suelo',
      floorHardness: 'Dureza del suelo',
      grassType: 'Tipo de césped',
      grasshybrid: 'Césped híbrido',
      none: 'Ninguna',
      hybridSystem: 'Sistema de hibridez',
      grassHeight: 'Altura de corte',
      grassProgram: 'Programa de riego',
      // DIRECT
      clubStats: 'Estadísticas del club',
      players: 'Jugadores',
      averageDistanceTraveled: 'Promedio distancia recorrida (km)',
      totalDistancePerTeam: 'Total distancia por equipo (km)',
      playerWithTheMostDistanceTraveled:
        'Jugador con más distancia recorrida (km)',
      live: 'directo',
      emptySubtitleLive: 'Todavía no existen eventos para este partido.',
      // COUNTDOWN
      realtime: 'Hora real',
      times: 'Tiempos',
      activities: 'Actividades',
      // ACTS
      comments: 'Comentarios',
      // DATA PROTECTION
      dataProtectionTitle: 'Política de Privacidad',
      // PRIVACY POLICY
      privacyPolicyTitle: 'Información básica sobre protección de datos',
      sessionExpired: 'La sesión ha expirado, vuelve a acceder a tu cuenta',
      // EMPTY
      emptyTitle: 'Datos no disponibles',
      emptyTitleProtocol: 'Partido sin actos protocolarios o comerciales',
      emptySubtitle: 'La información todavía no ha sido incluida por el club',
      emptySubtitleFullTime: 'No se han incluido eventos para este partido',
      emptySubtitleMatchRequest:
        'Los Clubes no han realizado ninguna solicitud para este partido',
      privateAccess: 'Login Office365',
      azureFailure:
        'No hemos podido iniciar sesión con tu cuenta de Office365, intenta de nuevo.',
      missedPenalty: 'Penalti fallado',
      substitutionInjury: 'Sustitucion lesion',
      substitutionTactical: 'Sustitucion táctica',
      localAndVisitant: 'local / visitante: ',
      refereeMatches: 'P.ARBITRADOS',
      backToHome: 'Volver al inicio',

      // FALLBACK
      fallBackErrorTitle: 'Ha habido un error',
      fallBackErrordeDesc: 'Por favor, recargue la página e inténtelo de nuevo',
    },
  },
  en: {
    translation: {
      languageId: 'EN',
      welcome: 'Welcome',
      login: 'Log in',
      profile: 'profile',
      register: 'Register',
      television: 'Television',
      showFilters: 'See Filters',
      filters: 'filters',
      lockText: 'Please, turn your device to use this.',
      radio: 'Radio',
      writtenOrDigitalPress: 'Press or digital media',
      clubMedia: 'Official club media outlets',
      other: 'Others',
      name: 'Name',
      lastName: 'Surname(s)',
      dni: 'ID/TIN',
      email: 'Email',
      mediaType: 'Media type',
      password: 'Password',
      newPassword: 'New Password',
      telephone: 'Phone number',
      cancel: 'Cancel',
      yes: 'Yes',
      no: 'no',
      season: 'Season',
      date: 'Date',
      confirm: 'Confirm',
      registerConfirmation: 'Register confirmation',
      registerConfirmationMessage:
        'Check your email inbox to proceed with validation',
      sendEmailAgain: 'Send email again',
      sendEmail: 'Send email',
      return: 'Go back',
      appName: 'Match Information Channel',
      appNameShort: 'Info Channel',
      changeLogo: 'Change logo',
      logout: 'Log out',
      deleteLogo: 'Delete logo',
      arbiterTeam: 'Referee team',
      kitSelector: 'KitSelector',
      grassStatus: 'Grass condition',
      matchSheet: 'Match sheet',
      protocolActs: 'Officias',
      commercials: 'Comercials acts',
      commercial: 'Commercial',
      protocolary: 'Official',
      arbitrationTeam: 'Referee team',
      countdown: 'Countdown',
      goBackTo: 'Go back to',
      next: 'Next',
      // Se debe traducir
      accessAppInformation: 'Access information on the',
      // Se debe traducir
      apps: 'Applications',
      allFemale: 'All',
      all: 'All',
      club: 'Club',
      competition: 'Competition',
      search: 'Search',
      cleanFilters: 'Clear filters',
      noOptions: 'No options',
      round: 'Round',
      globalStatistics: 'Overall Statistics',
      previous: 'Preview',
      direct: 'Live',
      passesCompleted: 'Passes completed (number + percentage)',
      passesCompletedAbv: 'PCom',
      longPasses: 'Successful long passes',
      longPassesAbv: 'LPCom',
      shortPasses: 'Successful short passes',
      shortPassesAbv: 'SPCom',
      shots: 'Shots (number/on goal)',
      shotsAbv: 'Sht',
      faults: 'Fouls (committed/received)',
      faultsAbv: 'Fou',
      offsides: 'Offsides',
      offsidesAbv: 'Off',
      goal: 'Goal',
      goals: 'Goals',
      goalsAbv: 'Goal',
      ownGoal: 'Own goal',
      recoveredBalls: 'Balls recovered',
      recoveredBallsAbv: 'BRec',
      minutesPlayed: 'Minutes played',
      minutesPlayedAbv: 'MinP',
      totalTackle: 'Challenges made',
      totalTackleAbv: 'ChM',
      head_coach: 'Coach',
      second_coach: 'Assistant coach',
      defender: 'Defender',
      midfielder: 'Midfielder',
      forward: 'Forward',
      minuteByMinute: 'Minute by minute',
      events: 'Events',
      matchStatistics: 'Match statistics',
      dashboard: 'Dashboard',
      local: 'Home',
      localClub: 'Home club',
      peninsular: 'Mainland Spain',
      stadium: 'Stadium',
      rainfall: 'Precipitation',
      humidity: 'Humidity',
      temperature: 'Temperature',
      accountValidated:
        'Your account has been activated, you can now access it',
      activeAccount: 'Your account is now active',
      weekday0: 'Sunday',
      weekday1: 'Monday',
      weekday2: 'Tuesday',
      weekday3: 'Wednesday',
      weekday4: 'Thursday',
      weekday5: 'Friday',
      weekday6: 'Saturday',
      loading: 'Loading',
      mainReferee: 'Head referee',
      shirt: 'T-shirt',
      shorts: 'Shorts',
      socks: 'Socks',
      irrigationProgramBeforeWarming: 'Prior to warm-up',
      irrigationProgramBeforeMatch: 'Prior to match',
      irrigationProgramDuringBreak: 'At the start of half-time',
      'var-referee': 'VAR',
      'avar-referee': 'AVAR',
      'assistant-referee-1': 'A1',
      'assistant-referee-2': 'A2',
      'fourth-referee': '4º',
      // Validations
      loginError: 'Login error',
      nameIsRequiredValidationError: 'Name is a required field',
      lastNameIsRequiredValidationError: 'Surname(s) is a required field',
      dniIsRequiredValidationError: 'ID/TIN is a required field',
      emailIsRequiredValidationError: 'Email is a required field',
      mediaNameIsRequiredValidationError:
        'Media outlet name is a required field',
      mediaTypeIsRequiredValidationError:
        'Media outlet type is a required field',
      telephoneIsRequiredValidationError: 'Phone number is a required field',
      passwordIsRequiredValidationError: 'Password is a required field',
      newPasswordIsRequiredValidationError: 'New Password is a required field',
      confirmPasswordIsRequiredValidationError:
        'The password must be confirmed',
      captchaIsRequiredValidationError: 'The captcha must be filled in',
      changeLogoError: "Your brand's logo could not be changed",
      editAccountError: 'Your profile could not be changed',
      editAccountSuccess: 'Your profile has been changed correctly',
      editPasswordError: 'Your password could not be changed',
      editPasswordSuccess: 'Your password as been changed correctly',
      fileTypeNotPermitted: 'File type not accepted; it must be JPG or PNG',
      mustChooseOption: 'You must select an option',
      mustHave2OrMoreLetters: 'It must contain 2 or more letters',
      mustHave3OrMoreLetters: 'It must contain 3 or more letters',
      mustHave15OrLessLetters: 'It must contain 15 or less letters',
      mustHave30OrLessLetters: 'It must contain 30 or less letters',
      mustHave50OrLessLetters: 'It must contain 50 or less letters',
      mustContainOnlyLetters: 'It must contain only letters',
      documentFormatInvalid: 'The format is not valid',
      invalidEmail: 'Invalid email',
      emailIsRequired: 'Email is required',
      properTelephoneSpanishFormat: 'It must be a valid Spanish phone number',
      smsCodeValidationError: 'Must enter an SMS code',
      smsCodeNotification_part_1:
        'We have sent you a text message to the phone + XX XXXXXXX',
      smsCodeNotification_part_2: '. Enter the code to login.',
      smsVerification: 'Check',
      addLogo: 'Add logo',
      addImage: 'Attach image',
      passwordFormatValidationError:
        'The password must contain from 8 to 20 characters, at least one upper case letter, a lowercase letter, a number and a special character',
      mustPassCaptcha: "Confirm you're not a robot",
      policyIsRequiredValidationError:
        'You must accept the Legal Terms and Privacy Policy',

      // Form labels
      enterName: 'Enter your name',
      enterLastName: 'Enter your surname(s)',
      enterDNI: 'Enter your ID number',
      enterEmail: 'Enter your email',
      mediaNameLabel: 'Media outlet name',
      enterMediaName: 'Enter the name of your media outlet',
      selectMediaType: 'Select the type of the media outlet',
      enterMediaTypeDescription: 'Enter the type of media outlet',
      enterTelephone: 'Enter your phone number',
      enterPassword: 'Enter your password',
      confirmPasswordLabel: 'Confirm password',
      confirmPassword: 'Confirm your password',
      confirmNewPassword: 'Confirm your new password',
      submit: 'Send',
      createAccount: 'Create account',
      editAccount: 'Edit account',
      editPassword: 'Change password',
      profesionalAdvise:
        '* The information will be processed exclusively for professional purposes',
      haveAccount: 'Have you already got an account?',
      noHaveAccount: 'Still haven’t got an account?',
      enterSmsCode: 'Enter the verification code',
      loginIntoAccount: 'Login',
      passwordRecovery: 'Password recovery',
      passwordIsRequired: 'Password required',
      passwordsMustMatch: 'Passwords must match',
      smsCode: 'SMS code',
      enterSMSCode: 'Enter the verification code',
      finalize: 'Finalise',
      dropzoneMessage1: 'Drag the photo you wish to upload into the area',
      dropzoneMessage2: 'or click on the file to select it',
      changePassword: 'Change password',
      confirmationSuccessMessage:
        'User validated successfully. Please, enter your details to log in to your account.',
      profileConditions:
        'In an effort to improve my experience, I consent to LaLiga creating a profile based on my browsing and consumption habits.',
      legalText1: 'I have read and accept the',
      legalTerms: 'Legal Terms',
      and: 'and',
      privacyPolicy: 'Privacy Policy',
      legalText2:
        'of the platform and confirm that I am 18 years of age or older.',

      // Toasts
      authFailed:
        'There was an error with the authentication; please, review your details',
      registerFailed: 'There was an error with the new user registration.',
      passwordRecoverySuccess: 'Follow the instructions sent by email.',
      passwordRecoveryFailed: 'There was an error with the password recovery',
      faultsIndicated: 'Faults indicated',
      resendEmailSuccess: 'A message has been sent to your email',
      resendEmailFailure: 'The email could not be sent',
      changePasswordSuccess: 'The password has been replaced successfully',
      changePasswordFailure: 'Your password could not be replaced',
      dataFetchFailure: 'The details could not be recovered',
      userActivated: 'The user is already activated',
      // GLOBAL STATS
      namePosition: 'name/position',
      goalsNoKey: 'goals',
      passes: 'passes',
      recoveries: 'recoveries',
      assists: 'assists',
      stops: 'saves',
      games: 'p.games',
      in: 'in',
      position: 'Position',
      birthDate: 'Date of birth',
      birthPlace: 'Place of birth',
      height: 'Height',
      weight: 'Weight',
      close: 'Close',
      goalPenaltis: 'Goals/Penalties',
      substitutions: 'Substitutions',
      shotsNoKey: 'shots',
      yellowCards: 'Yellow cards',
      yellowCard: 'Yellow card',
      redCards: 'Red cards',
      redCard: 'Red card',
      doubleYellowCards: 'Two yellow Cards',
      foulsReceivedMade: 'Fouls received/Faults made',
      whistlesFouls: 'Fouls called',
      penaltiesIndicated: 'Penalties awarded',
      squad: 'Squad',
      stats: 'Statistics',
      information: 'Information',
      signaledPlayersAre: 'The highlighted players are',
      inTheCategorySignaled: 'in the indicated categories for the season',
      inTheCategorySignaledMatch: 'in the indicated categories for the match',
      offside: 'Offside',
      checkUrl: 'Check if you wrote a correct url',
      goToWebsiteHome: 'Go to canalinformacionpartidos.laliga.es',
      report: 'Report',
      matchReports: 'Match reports',
      matchInfo: 'Match info',
      documentUnavailable: 'Document completion pending',
      // MATCH
      titulars: 'Starting players',
      substitutes: 'Substitutes',
      alignment: 'Line-up',
      trainer: 'Manager',
      globalStats: 'Club-Competition statistics',
      foundationYear: 'Year founded',
      total_shots: 'Total shots',
      total_faults: 'Total fouls',
      total_passes: 'Total passes',
      possession_percentage: 'Percentage of possession',
      double_yellow_card: 'Two yellow cards',
      total_fouls_conceded: 'Total fouls',
      red_card_2nd_yellow: 'Two yellow cards',
      corners_won: 'Corners won',
      total_red_cards: 'Total red cards',
      total_successful_passes_excl_crosses_corners: 'Total successful passes',
      won_matches: 'Matches won',
      total_losses_of_possession: 'Total losses of possession',
      tied_matches: 'Matches drawn',
      successful_corners_into_box: 'Goals from corners',
      total_shots_conceded: 'Total shots against',
      corner: 'Corner',
      red_cards: 'Red cards',
      yellow_cards: 'Yellow cards',
      total_passes_successfully: 'Total successful passes',
      win_matches: 'Matches won',
      total_possession_lost: 'Total losses of possession',
      lost_matches: 'Matches lost',
      tie_matches: 'Matches drawn',
      corner_goals: 'Goals from corners',
      total_shots_received: 'Total shots against',
      priorToBeginning: 'Prior to match',
      duringBreak: 'During half-time',
      afterTheMatch: 'Post-match',
      period: 'Period',
      actType: 'Event type',
      description: 'Description',
      observations: 'Observations',
      noObservations: 'No observations',
      // REFEREES
      totalWinnings: 'Total victories',
      totalDraws: 'Total draws',
      totalDefeats: 'Total losses',
      arbitratedMatches: 'Matches refereed',
      matchesWithReferees: 'Matches refereed',
      debut: 'Debut',
      arbitrationCollege: 'Referee association',
      total: 'total',
      DownloadOfficialDesignation: 'Download official designation',
      // KIT SELECTOR
      equipment: 'Uniform',
      referee: 'referee',
      rol: 'role',
      time: 'time',
      kit: 'uniform',
      rolHome: 'Home',
      rolAway: 'Visiting',
      downloadKitDesignation: 'Download official designation of KitSelector',
      downloadRefereeDesignation:
        'Download official designation of Referee team',
      downloadGrassDesignation: 'Download grass status report',
      downloadSheetDesignation: 'Download Match Sheet',
      downloadActsDesignation: 'Download Countdown Protocol',
      goalkeeper: 'Goalkeeper',
      player: 'Player',
      countAcronim: '°',
      // GREENKEEPER
      meteorology: 'weather',
      pitch: 'pitch',
      grass: 'grass',
      president: 'president',
      officialWeb: 'official website',
      relativeHumidity: 'Relative humidity',
      precipitations: 'Precipitation type',
      dimensions: 'dimensions',
      floorTemperarure: 'Ground temperature',
      floorHardness: 'Ground hardness',
      grassType: 'Grass type',
      grasshybrid: 'Hybrid',
      none: 'None',
      hybridSystem: 'Hybrid grass',
      grassHeight: 'Grass height',
      grassProgram: 'Irrigation programme',
      // DIRECT
      clubStats: 'Club statistics',
      players: 'Players',
      averageDistanceTraveled: 'Average distance covered (km)',
      totalDistancePerTeam: 'Total distance by team (km)',
      playerWithTheMostDistanceTraveled:
        'Player with the most distance covered',
      live: 'live',
      emptySubtitleLive: 'There are no events for this match yet',
      // COUNTDOWN
      realtime: 'Real time',
      times: 'Times',
      activities: 'Activities',
      // ACTS
      comments: 'Commentary',
      // DATA PROTECTION
      dataProtectionTitle: 'Privacy Policy',
      // PRIVACY POLICY
      privacyPolicyTitle: 'Basic data protection information',
      sessionExpired:
        'The session has expired; please, log in to your account again',
      // EMPTY
      emptyTitle: 'Data not available',
      emptyTitleProtocol: 'Match without formal or commercial acts',
      emptySubtitle: 'The club has not included the information yet',
      emptySubtitleFullTime: 'No events have been included for this match',
      emptySubtitleMatchRequest:
        'Clubs have not made any requests for this match',
      privateAccess: 'Login Office365',
      azureFailure:
        'Cannot login with your Office365 account at the moment, try again.',
      missedPenalty: 'Missed penalty',
      substitutionInjury: 'Substitution Injury',
      substitutionTactical: 'Substitution tactic',
      localAndVisitant: 'local / visitant: ',
      refereeMatches: 'Matches refereed',
      backToHome: 'Go to home',

      // FALLBACK
      fallBackErrorTitle: 'An error has occured',
      fallBackErrordeDesc: 'Please reload the page and try again',
    },
  },
};
